<template>
    <div class="example-drag">
        <div class="upload">
            <ul v-if="files.length" class="list-reset">
                <li v-for="(file) in files" :key="file.id" class="mb-4">
                    <div class="flex items-center">
                        <div class="w-4 h-4 flex items-center justify-center mr-2">
                            <i v-if="file.error" class="text-red fal fa-times"></i>
                            <i v-else-if="file.success" class="text-green fal fa-check"></i>
                            <i v-else-if="file.active" class="text-blue fas fa-spinner fa-spin"></i>
                        </div>
                        <div class="font-heading flex-1 truncate text-sm mr-2">{{file.name}}</div>

                        <div v-if="file.success && !file.active">
                            <button class="btn btn--sm btn--colored__red" @click.prevent="deleteFile(file)"><i
                                    class="fa fa-times"></i></button>
                        </div>
                    </div>
                    <div v-if="!file.success" class="help-text text-red">{{file.error}}</div>
                </li>
            </ul>
            <div class="p-4">
                <div class="text-center">
                    <h4>Drop files anywhere to upload</h4>
                    <p>or</p>
                    <label for="file" class="btn btn--outline__blue">Select Files</label>
                </div>
            </div>

            <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                <h3>Drop files to upload</h3>
            </div>

            <div class="example-btn">
                <file-upload
                        :post-action="url"
                        :headers="fileUploadHeader"
                        :multiple="true"
                        :drop="true"
                        :drop-directory="true"
                        @input-file="fileAdded"
                        @input-filter="inputFilter"
                        v-model="files"
                        ref="upload"
                        :accept="accept">
                </file-upload>
            </div>
        </div>
    </div>
</template>
<style>
    .example-drag .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
    }

    .example-drag .drop-active h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }

    .example-drag .upload .help-text.text-red {
        margin-top: 0px;
    }
</style>

<script>
    import FileUpload from 'vue-upload-component';
    import auth from '@/auth';

    export default {
        props: ['url', 'deleteUrl', 'value', 'accept'],

        components: {
            FileUpload,
        },

        data() {
            return {
                files: []
            }
        },

        computed: {
            fileUploadHeader() {
                return {
                    'Authorization': 'Bearer ' + auth.getToken(),
                    'Accept': 'application/json'
                };
            },
        },

        mounted() {
            if (this.value) {
                this.files = this.value.map(file => {
                    return {
                        name: file.filename,
                        success: (typeof file.success !== "undefined") ? file.success : true,
                        active: false,
                        error: (typeof file.error !== "undefined") ? file.error : false,
                        response: {
                            data: file
                        }
                    };
                });
            }
        },

        methods: {
            deleteFile(file) {
                this.$api().delete(this.deleteUrl + '/' + file.response.data.id).then(() => {
                    this.$refs.upload.remove(file);
                });
            },

            inputFilter(newFile, oldFile) {
                if (Boolean(newFile) !== Boolean(oldFile)) {
                    this.$emit('activeFileUpload', false);
                }
            },

            fileAdded(newFile, oldFile) {
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true;
                        this.$emit('activeFileUpload', true);
                    }
                }

                if (newFile && oldFile && newFile.error !== oldFile.error) {
                    if (typeof newFile.response.errors !== "undefined") {
                        newFile = this.$refs.upload.update(newFile, {error: newFile.response.errors.file[0]});
                    } else {
                        newFile = this.$refs.upload.update(newFile, {error: 'Something went wrong.'});
                    }
                }
            }
        },

        watch: {
            files(files) {
                this.$emit('input', files.filter(item => item.success));
            }
        }
    }
</script>